/*
 * filename: table.js
 * Get the user data from store and show
 * */

import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn,
} from 'material-ui/Table';
import RaisedButton from 'material-ui/RaisedButton';
import { Field, reduxForm, reset } from 'redux-form';

import { renderTextField } from '../components/reduxFields';
import { showFormatedDate, base64Encode, resetFiltersAndSorting } from '../actions/utilAction';
import history from '../history';
import PaginatorCustom from '../components/paginationCustom';
import { getOrganizationAuthorization } from '../../src/modules/Dashboards/actions/StaffDashboardActions';
import Tooltip from '../components/Tooltip';
import SortingCustom from '../components/SortingCustom';

/**
 * A simple table demonstrating the hierarchy of the `Table` component and its sub-components.
 */
class AuthorizationTable extends Component {

  constructor(props) {
    super(props);
    this.filter = {
      sort_Column: '',
      sort_order: '',
      searchText: '',
    };
    this.handleSearchAuths = this.handleSearchAuths.bind(this);
    this.handleSearchChange = this.handleSearchChange.bind(this);
    this.setSortColumn = this.setSortColumn.bind(this);
}

  loadOrganizationAuthorization(page_number) {
    let searchObj = {
      pageNumber: page_number ? page_number : 1,
      pageSize: 10,
      sort_fields: this.filter.sort_Column || '',
      sort_order: this.filter.sort_order || '',
      contain_filters: { SearchText: this.filter.searchText || null, 
      viewTeamClientsOnly: this.props.viewTeamClientsOnlyPermission ? '1' : '0' },
    };
    this.props.SendQueryparams(searchObj)
    this.props.getOrganizationAuthorization(searchObj);
  }

  handleViewAuthorizationClick = (event, obj) => {
    let clientId = base64Encode(`${obj.clientId}`);
    history.push(`/client/authorization/${clientId}`);
  };

  handleSearchAuths() {
    return false;
  }

  handleReset = () => {
    this.props.dispatch(reset('AuthorizationTableForm'));
    resetFiltersAndSorting(this.filter, 'id', true);
    this.filter.sort_Column = '';
    this.filter.sort_order = '';
    this.loadOrganizationAuthorization();
  };

  handleSearchChange(event) {
    if (event.target.value.length > 0) {
      this.filter.searchText = event.target.value;
      this.loadOrganizationAuthorization();
    } else if (event.target.value.length === 0) {
      this.filter.searchText = '';
      this.loadOrganizationAuthorization();
    }
  }

  setSortColumn(col_name, col_order) {
    if (col_name) {
      this.filter.sort_Column = col_name;
      this.filter.sort_order = col_order;
      this.loadOrganizationAuthorization();
    }
  }

  showTableData() {
    return this.props.OrganizationAuthorization.data.map((data) => {

      return (
        <TableRow key={data.authorizationId} style={{ background: `${data.warningColorCode}` }}>
          <TableRowColumn style={{ width: '35%' }}>{data.clientName}</TableRowColumn>
          <TableRowColumn style={{ width: '25%' }}>
            {data.authorizationTitle !== '' ?
              <Tooltip Description={data.authorizationTitle} />
              : null} {data.authorizationTitle}
          </TableRowColumn>
          {/* <TableRowColumn style={{ width: '20%' }}>{data.therapyName}</TableRowColumn> */}
          <TableRowColumn style={{ width: '27%' }}>{showFormatedDate(data.endDate)}</TableRowColumn>
          {/* <TableRowColumn>{data.remainedUnits}</TableRowColumn> */}
          <TableRowColumn style={{ width: '13%' }}><button onClick={(e) => this.handleViewAuthorizationClick(e, data)} type="button" title="View Authorization" className="tbactionbtn blackfont"><i className="fa fa-eye" aria-hidden="true"></i></button></TableRowColumn>
        </TableRow>
      );
    });
  }

  render() {
    const { handleSubmit, OrganizationAuthorization } = this.props;
    const authList =  (OrganizationAuthorization && OrganizationAuthorization.data) || []
    return (
      <div>
        <div className="row">
          <div className="col-sm-12">
            <div className="row end-flex">
              <div className="col-sm-9 mtm-27">
                <form className="readmin-form custom_form" onSubmit={handleSubmit(this.handleSearchAuths)}>
                  <Field
                    name="auth"
                    floatingLabelText="Search"
                    maxLength='25'
                    onChange={this.handleSearchChange}
                    component={renderTextField}
                  />
                </form>
              </div>
              <div className="reset-btn col-sm-3 btn_rt">
                <RaisedButton className="grey_btn ml_15" onTouchTap={this.handleReset}>Reset</RaisedButton>
              </div>
            </div>
          </div>
        </div>
        <Table>
          <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
            <TableRow >
              <TableHeaderColumn style={{ width: '35%' }}><SortingCustom noSort={!authList.length} setSortColumn={this.setSortColumn} columnName='clientName' displayName='Client Name' /></TableHeaderColumn>
              <TableHeaderColumn style={{ width: '25%' }}>Title</TableHeaderColumn>
              {/* <TableHeaderColumn style={{ width: '25%' }}>Therapy Name</TableHeaderColumn> */}
              <TableHeaderColumn style={{ width: '27%' }}><SortingCustom noSort={!authList.length} setSortColumn={this.setSortColumn} columnName='endDate' displayName='Expiration Date' /></TableHeaderColumn>
              {/* <TableHeaderColumn>Unit(s) Remaining</TableHeaderColumn> */}
              <TableHeaderColumn style={{ width: '13%' }}>View</TableHeaderColumn>
            </TableRow>
          </TableHeader>
          <TableBody displayRowCheckbox={false}>
            {this.props.OrganizationAuthorization && this.props.OrganizationAuthorization.data && this.props.OrganizationAuthorization.data.length > 0 ?
              this.showTableData()
              :
              <TableRow>
                <TableRowColumn colSpan="4">No Record Found</TableRowColumn>
              </TableRow>
            }
          </TableBody>
        </Table>
        {this.props.OrganizationAuthorization.data && this.props.OrganizationAuthorization.data.length ?
          <PaginatorCustom data={this.props.OrganizationAuthorization.meta} handlePageChange={(page_number) => this.loadOrganizationAuthorization(page_number)} />
          : null}
      </div>
    );
  }
}

AuthorizationTable = reduxForm({
  form: 'AuthorizationTableForm',
})(AuthorizationTable);

function mapStateToProps(state) {
  //  console.log('state.staff_dashboard.OrganizationAuthorization..............',state.staff_dashboard.OrganizationAuthorization);
  return {
    OrganizationAuthorization: state.staff_dashboard ? state.staff_dashboard.OrganizationAuthorization : {},
    RightPanel_loading: state.staff_dashboard.RightPanel_loading,
  };
}

export default connect(mapStateToProps, { getOrganizationAuthorization })(AuthorizationTable);



// WEBPACK FOOTER //
// ./src/adminCharts/AuthorizationTable.js